// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  data() {
    return {
      title: '', // 面包屑标题
      search: '',
      modal1: false, // 模态框显示开关，true显示   false不显示
      addbrand: false, // 模态框显示开关，true显示   false不显示
      param: '', // 点击编辑、删除的时候对应操作的那个id
      friendname: '', // 友链名称
      friendlink: '', // 友链链接
      id: '', // 友链id
      putpage: '', // 存储页数
      columns7: [
        {
          // type: 'index',
          title: '排序',
          width: 100,
          align: 'center',
          key: 'sort_no',
          // sortable:true,
          render: (h, params) => {
            const self = this;
            return h('div', [
              h('Input', {
                props: {
                  placeholder: '请输入',
                  value: params.row.sort_no,
                  // 'v-model':value
                },
                on: {
                  'on-blur': (event) => {
                    // 这是一个失去焦点事件
                    const sort = event.target.value;
                    this.getSort(sort, params.row.id);
                  },
                },
              }),
            ]);
          },
        },
        {
          title: '链接名称',
          key: 'labelname',
          render: (h, params) => h('div', [h('strong', params.row.friendname)]),
        },
        {
          title: '链接地址',
          key: 'addtime',
          render: (h, params) => h('div', [h('strong', params.row.friendlink)]),
        },
        {
          title: '操作时间',
          key: 'addtime',
          render: (h, params) => h('div', [h('strong', params.row.addtime)]),
        },
        {
          title: '操作选项',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) =>
            h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.show(params.row.id);
                      // this.show(params);
                    },
                  },
                },
                '编辑',
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.remove(params);
                    },
                  },
                },
                '删除',
              ),
            ]),
        },
      ],
    };
  },
  created() {
    const self = this;
    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 500);
    const spage = this.$route.query.page;
    const asearch = this.$route.query.search;
    axios({
      method: 'post',
      url: '/admin/friendlink/friendList',
      data: { page: spage, search: asearch },
    })
      .then((response) => {
        checkRule(response, self); // 检查是否有权限
        self.putpage = spage;
        self.$store.commit('getFriendParam', response.data);
      })
      .catch((response) => {});
  },
  // 用来获取VUEX中的文件
  computed: {
    data() {
      return this.$store.state.friendlink.friendlistshow;
    },
    page() {
      return this.$store.state.friendlink.friendlist.total;
    },
  },
  methods: {
    // 更新排序方法(完成)
    getSort(value, artid) {
      const self = this;
      for (const el of self.data) {
        console.log(el.id);
        if (el.id == artid) {
          el.sort_no = value;
        }
      }
      // 更新排序请求
      axios({
        method: 'post',
        url: '/admin/friendlink/friendSort',
        data: {
          param: this.data,
        },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          self.$store.commit('getFriendParamAgain', self.putpage, self.search);
          self.$Message.success('操作成功');
        })
        .catch((response) => {});
    },
    // 添加友链模态框
    addArticle() {
      this.param = '';
      this.friendname = '';
      this.friendlink = '';
      this.addbrand = true;
    },
    // 执行添加修改友情链接
    ok_addbrand() {
      const self = this;
      axios({
        method: 'post',
        url: '/admin/friendlink/friendUpdate',
        data: {
          friendname: this.friendname,
          id: this.param,
          friendlink: this.friendlink,
        },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
            self.$store.commit(
              'getFriendParamAgain',
              self.putpage,
              self.search,
            );
            self.data6.splice(param.index, 1); // 如果把那个1改成0，就是不删除
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        }); //* /
    },
    // 点击取消之后走的方法
    cancel_addbrand() {
      this.addbrand = false;
    },
    // 分页的钩子函数，当跳页的时候重新请求（将页码发给后台）
    getpage(page) {
      console.log(page);
      if (page == undefined) {
        page = 1;
      }
      this.putpage = page;
      const self = this;
      // 分页
      axios({
        method: 'post',
        url: '/admin/friendlink/friendList',
        data: {
          page,
          search: self.search,
        },
      })
        .then((response) => {
          self.$store.commit('getFriendParam', response.data);
        })
        .catch((response) => {});
      this.$router.push({
        path: '/friendlink', // 这是路由名称
        query: { page, search: self.search },
      });
    },
    /**
     * 编辑当前品牌
     * localStorage html5新定义的属性，存在兼容问题  使用方法参考下边网址
     * https://www.cnblogs.com/st-leslie/p/5617130.html
     * https://segmentfault.com/q/1010000010175869?sort=created
     */
    show(index) {
      const self = this;
      axios({
        method: 'post',
        url: '/admin/friendlink/friendEdit',
        data: { friendid: index },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          self.param = response.data.friendinfo.id;
          self.friendname = response.data.friendinfo.friendname;
          self.friendlink = response.data.friendinfo.friendlink;
        })
        .catch((response) => {});
      this.addbrand = true;
    },
    /**
     * 删除当前标签
     * 同页面刷新不建议使用路由，再此请求数据
     * const定义的变量不可修改
     */
    remove(brandid) {
      this.modal1 = true;
      this.param = brandid;
    },
    ok() {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/friendlink/friendDel',
        data: { id: self.param.row.id },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            const numm = response.data.count;
            const mo = numm % 10; // 判断剩余总数摸10是否是0
            const pagepage = Math.ceil(numm / 10);
            if (
              self.param.index == 0 &&
              self.putpage != 1 &&
              mo == 0 &&
              self.putpage != pagepage
            ) {
              // 判断当前所在页是否是最后一页。
              self.putpage -= 1;
            }
            self.$store.commit(
              'getFriendParamAgain',
              self.putpage,
              self.search,
            );
            self.$Message.success(response.data.msg);
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {});
    },
    cancel() {
      this.modal1 = false;
    },
  },
};
